var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureLevelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 -4.37114e-08C0.447715 -1.95703e-08 -5.92382e-07 0.447716 -5.68241e-07 1L-3.93402e-07 5C-3.69261e-07 5.55228 0.447715 6 1 6L5 6C5.55228 6 6 5.55228 6 5L6 1C6 0.447715 5.55228 -2.42698e-07 5 -2.18557e-07L1 -4.37114e-08ZM8 9C8 8.44771 8.44772 8 9 8L13 8C13.5523 8 14 8.44772 14 9L14 13C14 13.5523 13.5523 14 13 14L9 14C8.44771 14 8 13.5523 8 13L8 9ZM8 1C8 0.447715 8.44772 -3.69261e-07 9 -3.93403e-07L13 -5.68248e-07C13.5523 -5.92389e-07 14 0.447715 14 0.999999L14 5C14 5.55228 13.5523 6 13 6L9 6C8.44772 6 8 5.55228 8 5L8 1ZM-2.1855e-07 9C-2.42691e-07 8.44772 0.447715 8 1 8L5 8C5.55228 8 6 8.44772 6 9L6 13C6 13.5523 5.55228 14 5 14L1 14C0.447715 14 -1.95703e-08 13.5523 -4.37114e-08 13L-2.1855e-07 9Z",
    fill: "#4A49CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureLevelIcon);
export default __webpack_public_path__ + "static/media/feature-level-icon.97faecc5f940042e42de486cf60a1e59.svg";
export { ForwardRef as ReactComponent };